import { render, staticRenderFns } from "./ImageGallery.vue?vue&type=template&id=7dfcf6c8&"
import script from "./ImageGallery.vue?vue&type=script&lang=ts&"
export * from "./ImageGallery.vue?vue&type=script&lang=ts&"
import style0 from "./ImageGallery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AdaptiveImageNew: require('/tmp/build_71ad00c4/src/components/media/AdaptiveImageNew.vue').default,ModalImageGalleryItem: require('/tmp/build_71ad00c4/src/components/modal/ImageGallery/Item.vue').default,HorizontalScrollSlider: require('/tmp/build_71ad00c4/src/components/layout/HorizontalScrollSlider.vue').default,ModalImageGalleryWrapper: require('/tmp/build_71ad00c4/src/components/modal/ImageGallery/Wrapper.vue').default,BlockWrapper: require('/tmp/build_71ad00c4/src/components/block/BlockWrapper.vue').default})
